export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/environments/environment.ts